import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleVessel = {
  namespaced: true,

  state: {
    name: 'project-asset',
    selProjectId: null, 
    selProjectVesselIds: [],
    selVesselId: null
  },

  mutations,
  getters,
  actions
}

export default moduleVessel;